"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var smoothScroll_1 = require("../../modules/smoothScroll");
var languagePageIndex = /** @class */ (function () {
    function languagePageIndex() {
        this.images = null;
        if ($(window).width() > 767) {
            this.getCardsImages();
        }
        smoothScroll_1.default.getInstance().init();
    }
    languagePageIndex.getInstance = function () {
        return new languagePageIndex();
    };
    languagePageIndex.prototype.getCardsImages = function () {
        var _self = this, url = $('#hero-cards').data('url');
        $.ajax({
            url: url + '/cards',
            method: "GET",
            dataType: "json"
        }).done(function (data) {
            if (data.length > 7) {
                _self.images = data;
                _self.initCardFlip();
            }
        });
    };
    languagePageIndex.prototype.initCardFlip = function () {
        var $cards = $('.js-flip-hero-cards'), _self = this;
        var cardSequence = [
            $cards.eq(0),
            $cards.eq(4),
            $cards.eq(3),
            $cards.eq(1)
        ];
        var imageChunks = chunkArray(_self.images, 4), frontBackChunks = {
            0: chunkArray(imageChunks[0], 2),
            1: chunkArray(imageChunks[1], 2),
            3: chunkArray(imageChunks[2], 2),
            4: chunkArray(imageChunks[3], 2)
        };
        setInterval(function () {
            var $card = cardSequence[0], $front = $card.find('.hero__card-front'), $back = $card.find('.hero__card-back'), chunk = frontBackChunks[$card.index()];
            if ($card.hasClass('flip')) {
                $front.css({
                    'background-image': 'url(' + chunk[0][Math.floor(Math.random() * chunk[0].length)] + ')'
                });
            }
            else {
                $back.css({
                    'background-image': 'url(' + chunk[1][Math.floor(Math.random() * chunk[1].length)] + ')'
                });
            }
            $card.toggleClass('flip');
            cardSequence.push(cardSequence.shift());
        }, 2000);
        function chunkArray(arr, n) {
            var rest = arr.length % n, restUsed = rest, partLength = Math.floor(arr.length / n), result = [];
            for (var i = 0; i < arr.length; i += partLength) {
                var end = partLength + i, add = false;
                if (rest !== 0 && restUsed) {
                    end++;
                    restUsed--;
                    add = true;
                }
                result.push(arr.slice(i, end));
                if (add) {
                    i++;
                }
            }
            return result;
        }
    };
    return languagePageIndex;
}());
exports.default = languagePageIndex;
